import { Typography } from "@mui/material";


export default function PreviosSession({ setSelectedPrevMessage }: any) {
    const previousMessages = localStorage.getItem('conversation') ? JSON.parse(localStorage.getItem('conversation')) : [];

    return (
        <div style={{
            padding: "8px 16px", 
            overflowY: "auto", 
            flexGrow: "1", 
            '&::-webkitScrollbar': {
                display: 'none',
            },
            scrollbarWidth: 'none',
        }}>
            {previousMessages?.length > 0 ?
                <>{
                    previousMessages?.map((element, index) => {
                        const dateObject = new Date(element?.time);
                        const optionsDate = { year: 'numeric', month: 'short', day: 'numeric' };
                        const formattedDate = dateObject.toLocaleDateString('en-US', optionsDate);
                        const optionsTime = { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true };
                        const formattedTime = dateObject.toLocaleTimeString('en-US', optionsTime);
                        const timeStamp = `${formattedDate} ${formattedTime}`;
                        return (
                            <div style={{ padding: "6px 0", cursor: "pointer" }} key={index} onClick={() => { setSelectedPrevMessage(element?.text) }}>
                                <Typography fontWeight={600} textAlign={"left"}  >{timeStamp}</Typography>
                            </div>
                        )
                    })
                }</>
                :
                <Typography fontWeight={600} fontSize={20} >No Previous Session</Typography>

            }
        </div>
    );
}
